<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-no-padding">
                <form class="form">
                    <div class="form-row row">
                        <label class="col-12">{{ $t('plans.form.label') }}</label>
                        <input ref="label" type="text" v-model="label" class="form-input col-12"/>
                    </div>
                    <!--<div class="form-row row">
                        <div class="col-12 simple-checkbox">
                            <input type="checkbox" name="groupEdit" id="groupEdit" v-model="groupEdit"/>
                            <label for="groupEdit">{{ $t('plans.form.groupEdit') }}</label>
                        </div>
                    </div>-->
                </form>
            </div>
        </div>
        <Toolbar class="not-fixed">
            <Btn class="primary" @click.native.stop="valid">
                {{ $t('global.save') }}
            </Btn>
            <Btn @click.native.stop="cancel">
                {{ $t('global.cancel') }}
            </Btn>
        </Toolbar>
    </div>

</template>

<script>
    import Toolbar from '@/components/ui/Toolbar';
    import AddressField from '@/components/ui/fields/AddressField';
    import Btn from "@/components/ui/Button";
    import MiniMap from '@/components/plans/map/MiniMap';

    export default {
        components: {
            Toolbar,
            Btn,
            MiniMap

        },
        data () {
            return {
                label: '',
                obj: null,
                editMode: false,
                groupEdit: false
            }
        },
        methods: {
            resetForm: function(){
                this.label = '';
            },
            cancel: function(){
                this.resetForm();
                this.$emit('close','add','group');
            },
            valid: function(){
                if(this.editMode){
                    this.obj.name = this.label;
                    this.$emit('editGroup',this.obj,this.groupEdit);
                }
                else {
                    var obj = {
                        label: this.label
                    }

                    this.$emit('addGroup', obj);
                }
                //this.resetForm();
            },
            edit: function(edit,obj){
                if(edit == null){
                    edit = false;
                }
                this.editMode = edit;
                if(obj != null) {
                    this.obj = obj;
                    this.label = obj.name;
                }
                if(!edit){
                    this.$refs.label.focus();
                }
            }
        },
        props: ['parent'],
    }
</script>

<style lang="scss" scoped>

</style>